import { permissionService, RoleType } from '@/services/permissionService';
import { computed, onMounted, ref } from 'vue';

export function usePermissions() {
  const initialized = ref(false);

  onMounted(async () => {
    if (!permissionService.initialized()) {
      await permissionService.initAsync();
    }
    initialized.value = true;
  });

  const hasRole = (role: RoleType): boolean => {
    return permissionService.hasRole(role);
  };

  const hasAnyRole = (roles: RoleType[]): boolean => {
    return permissionService.hasAllRoles(roles);
  };

  const hasAllRoles = (roles: RoleType[]): boolean => {
    return permissionService.hasAllRoles(roles);
  };

  const canViewProdukte = computed(() => initialized.value && permissionService.canViewProdukte());

  const canEditProdukte = computed(() => initialized.value && permissionService.canEditProdukte());

  const canViewStandorte = computed(
    () => initialized.value && permissionService.canViewStandorte()
  );

  const canEditStandorte = computed(
    () => initialized.value && permissionService.canEditStandorte()
  );

  const canViewPartner = computed(() => initialized.value && permissionService.canViewPartner());

  const canEditPartner = computed(() => initialized.value && permissionService.canEditPartner());

  const canViewAbholungen = computed(
    () => initialized.value && permissionService.canViewAbholungen()
  );

  const canEditAbholungen = computed(
    () => initialized.value && permissionService.canEditAbholungen()
  );

  const canViewEinlieferungen = computed(
    () => initialized.value && permissionService.canViewEinlieferungen()
  );

  const canEditEinlieferungen = computed(
    () => initialized.value && permissionService.canEditEinlieferungen()
  );

  const canViewAblieferungen = computed(
    () => initialized.value && permissionService.canViewAblieferungen()
  );

  const canEditAblieferungen = computed(
    () => initialized.value && permissionService.canEditAblieferungen()
  );

  const canViewBestaende = computed(
    () => initialized.value && permissionService.canViewBestaende()
  );

  const canEditBestaende = computed(
    () => initialized.value && permissionService.canEditBestaende()
  );

  const canViewNachweise = computed(
    () => initialized.value && permissionService.canViewNachweise()
  );

  const canViewNachweisverfolgung = computed(
    () => initialized.value && permissionService.canViewNachweisverfolgung()
  );

  const canAccessCockpit = computed(
    () => initialized.value && permissionService.canAccessCockpit()
  );

  const canAccessReports = computed(
    () => initialized.value && permissionService.canAccessReports()
  );

  const canAccessYtdReport = computed(
    () => initialized.value && permissionService.canAccessYtdReport()
  );

  const canAccessGenericImport = computed(
    () => initialized.value && permissionService.canAccessGenericImport()
  );

  const canImportInbound = computed(
    () => initialized.value && permissionService.canImportInbound()
  );

  const canImportOutbound = computed(
    () => initialized.value && permissionService.canImportOutbound()
  );

  const canViewZertifikate = computed(
    () => initialized.value && permissionService.canViewZertifikate()
  );

  const canEditZertifikate = computed(
    () => initialized.value && permissionService.canEditZertifikate()
  );

  const canViewBilanzen = computed(() => initialized.value && permissionService.canViewBilanzen());

  const canEditBilanzen = computed(() => initialized.value && permissionService.canEditBilanzen());

  const canViewPocs = computed(() => initialized.value && permissionService.canViewPocs());

  return {
    initialized,

    hasRole,
    hasAnyRole,
    hasAllRoles,

    canViewProdukte,
    canEditProdukte,
    canViewStandorte,
    canEditStandorte,
    canViewPartner,
    canEditPartner,
    canViewAbholungen,
    canEditAbholungen,
    canViewEinlieferungen,
    canEditEinlieferungen,
    canViewAblieferungen,
    canEditAblieferungen,
    canViewBestaende,
    canEditBestaende,
    canViewNachweise,
    canViewNachweisverfolgung,
    canAccessCockpit,
    canAccessReports,
    canAccessGenericImport,
    canImportInbound,
    canImportOutbound,
    canViewZertifikate,
    canEditZertifikate,
    canViewBilanzen,
    canEditBilanzen,
    canViewPocs,
    canAccessYtdReport,

    RoleType
  };
}
